import { Navigate } from "react-router-dom";
import Cookies from 'js-cookie';

export default function PrivateRoute({ children }) {
  let token = Cookies.get("e_learning_token");
  return token ? children : <Navigate to="/login" />;
}
